import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { DocumentViewComponent } from './document-view/document-view.component';
import { SearchComponent } from './search/search.component';
import { FilterComponent } from './search/filter/filter.component';
import { HeaderComponent } from './header/header.component';
import { getGermanPaginatorIntl } from './german-paginator-intl';
// Angular Material Components
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatCheckboxModule, MatNativeDateModule} from '@angular/material';
import {MatButtonModule} from '@angular/material';
import {MatInputModule} from '@angular/material/input';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatBadgeModule} from '@angular/material/badge';
import {MatSliderModule} from '@angular/material/slider';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatMenuModule} from '@angular/material/menu';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatListModule} from '@angular/material/list';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatCardModule} from '@angular/material/card';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatTableModule} from '@angular/material/table';
import {MatSortModule} from '@angular/material/sort';
import {MatPaginatorModule, MatPaginatorIntl} from '@angular/material/paginator';



// import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PdfViewerModule } from 'ng2-pdf-viewer';

// Dialog
import {MerklisteDialogComponent} from './merkliste-dialog/merkliste-dialog.component';
import {AnfrageDialogComponent} from './anfrage-dialog/anfrage-dialog.component';
import {ShibbolethDialogComponent} from './shibboleth-dialog/shibboleth-dialog.component';

// Third Party
import { MarkdownToHtmlModule } from 'markdown-to-html-pipe';
import { NgxGalleryModule } from 'ngx-gallery';
import { TextSearchComponent } from './search/text-search/text-search.component';
import { ListItemComponent } from './list-item/list-item.component';
import { AccountComponent } from './account/account.component';
import { LoginComponent } from './login/login.component';
import { CartDialogComponent } from './cart-dialog/cart-dialog.component';
import { Ng5SliderModule } from 'ng5-slider';
import { CarouselModule } from 'ngx-owl-carousel-o';

import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxAudioPlayerModule } from 'ngx-audio-player';

import { Doctyp3Component } from './document-view/doctyp3/doctyp3.component';
import { Doctyp4Component } from './document-view/doctyp4/doctyp4.component';
import { Doctyp5Component } from './document-view/doctyp5/doctyp5.component';
import { Doctyp6Component } from './document-view/doctyp6/doctyp6.component';
import { Doctyp8Component } from './document-view/doctyp8/doctyp8.component';
import { InfoDialogComponent } from './info-dialog/info-dialog.component';
import { Doctyp2Component } from './document-view/doctyp2/doctyp2.component';








@NgModule({
  declarations: [
    AppComponent,
    DocumentViewComponent,
    SearchComponent,
    FilterComponent,
    HeaderComponent,
    TextSearchComponent,
    ListItemComponent,
    // Dialog
    MerklisteDialogComponent,
    AnfrageDialogComponent,
    ShibbolethDialogComponent,
    AccountComponent,
    LoginComponent,
    CartDialogComponent,
    Doctyp3Component,
    Doctyp4Component,
    Doctyp5Component,
    Doctyp6Component,
    Doctyp8Component,
    InfoDialogComponent,
    Doctyp2Component
  ],
  imports: [
    BrowserModule,
    NgxChartsModule,
    NgxAudioPlayerModule,
    PdfViewerModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgxGalleryModule,
    MatCheckboxModule,
    MatCheckboxModule,
    MatButtonModule,
    MatInputModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatBadgeModule,
    MatRadioModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatGridListModule,
    MatCardModule,
    MatStepperModule,
    MatTabsModule,
    MatExpansionModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatDialogModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MarkdownToHtmlModule,
    MatNativeDateModule,
    Ng5SliderModule,
    CarouselModule
  ],
  entryComponents: [
    MerklisteDialogComponent,
    InfoDialogComponent,
    AnfrageDialogComponent,
    ShibbolethDialogComponent,
    CartDialogComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useValue: getGermanPaginatorIntl() }
  ],
  // LESSON-PETER: Hier waren die app-merkliste-snackbar und der
  // Dialog drin. i.d.R. wird nur eine einzige (root)-Komponente
  // gebootstrapped. die anderen sachen (v.a. dialogs) die während
  // der runtime generiert werden kommen in entry-components
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
